import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchVerticalTL } from '../../../sportradar-widgets/SrWidgetMatchVerticalTL';

function BetradarMTStatisticsVerticalTimeline({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetMatchVerticalTL matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsVerticalTimeline;
